import React from "react";

const OtpremnicaZaStampu = ({ podaci }) => {
  const {
    BrojOtpremnice = "",
    Datum = "",
    Klijent = "",
    Firma = "",
    Registracija = "",
    Vozac = "",
    Napomena = "",
    Stavke = [],
    /* Zbir tezine racuna procedura, ne stampa: artikal nosi tezinu po jedinici,
       pa je ukupno = kolicina * ta tezina. `BezTezine` je broj stavki ciji artikal
       NEMA upisanu tezinu — zbir je tada nepotpun i to se mora reci. */
    UkupnoNeto = "",
    UkupnoBruto = "",
    BezTezine = 0,
  } = podaci ?? {};

  const nbspIfEmpty = (v) =>
    v === 0 ? "0" : v === null || v === undefined || v === "" ? "\u00A0" : v;

  const printStyles = `
    * { box-sizing: border-box; }
    html, body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      color: #000;
      font-size: 11pt;
      background: #fff;
    }

    @page {
      size: A4 portrait;
      margin: 16mm 14mm;
    }

    #otpremnica-page {
      margin: 10% 1px 0 1px;
      width: 100%;
    }

    .page-title {
      text-align: center;
      font-size: 22pt;
      font-weight: 700;
      margin: 0 0 14px 0;
    }

    .meta-grid {
      display: grid;
      grid-template-columns: 180px 1fr;
      gap: 0;
      border: 1px solid #000;
      border-bottom: none;
      margin-bottom: 18px;
    }

    .meta-label,
    .meta-value {
      min-height: 34px;
      padding: 8px 10px;
      border-bottom: 1px solid #000;
    }

    .meta-label {
      font-weight: 700;
      border-right: 1px solid #000;
      background: #f2f2f2;
    }

    .meta-value {
      word-break: break-word;
    }

    .items-title {
      font-size: 13pt;
      font-weight: 700;
      margin: 0 0 8px 0;
    }

    table.items-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 10.5pt;
    }

    .items-table th,
    .items-table td {
      padding: 8px 6px;
      vertical-align: middle;
      word-break: break-word;
    }

    .items-table th {
      background: #e9e9e9;
      font-weight: 700;
      text-align: center;
    }

    .col-rb      { width: 5%;  text-align: center; }
    .col-sifra   { width: 10%; text-align: center; }
    .col-artikal { width: 27%; }
    .col-kolicina{ width: 10%; text-align: right; }
    .col-jm      { width: 9%;  text-align: center; }
    /* Tezina: otpremnica ide i kao papir na granicu, pa joj treba kilaza. */
    .col-neto    { width: 11%; text-align: right; }
    .col-bruto   { width: 11%; text-align: right; }
    .col-magacin { width: 17%; }

    /* Zbirni red — odvojen debljom linijom, da se ne cita kao jos jedna stavka. */
    .red-zbir td { font-weight: bold; border-top: 2px solid #000 !important; }

    /* Upozorenje kad zbir nije potpun. Ne sme da bude sitno: na granici se po
       ovom papiru postupa, pa carinik mora da vidi da tezina nije konacna. */
    .zbir-nepotpun {
      margin-top: 4px;
      font-size: 11px;
      font-style: italic;
    }

    .text-center { text-align: center; }
    .text-right  { text-align: right; }

    .note-box {
      margin-top: 18px;
      border: 1px solid #000;
    }

    .note-title {
      padding: 8px 10px;
      font-weight: 700;
      background: #f2f2f2;
      border-bottom: 1px solid #000;
    }

    .note-value {
      min-height: 70px;
      padding: 10px;
      white-space: pre-wrap;
      word-break: break-word;
    }

    .signature-wrap {
      margin-top: 34px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }

    .signature-box {
      text-align: center;
    }

    .signature-line {
      margin-top: 45px;
      border-top: 1px solid #000;
      padding-top: 6px;
      font-size: 10pt;
    }

    .fontSizeTd {
      font-size: 18px;
      font-weight: 300;
      padding-top: 1% !important;
      padding-bottom: 1% !important;
    }

    @media print {
      * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
  `;

  return (
    <div id="otpremnica-page">
      <style>{printStyles}</style>

      <div className="page-title">OTPREMNICA</div>

      <div className="meta-grid">
        <div className="meta-label">Broj otpremnice</div>
        <div className="meta-value">{nbspIfEmpty(BrojOtpremnice)}</div>

        <div className="meta-label">Datum</div>
        <div className="meta-value">{nbspIfEmpty(Datum)}</div>

        <div className="meta-label">Klijent</div>
        <div className="meta-value">{nbspIfEmpty(Klijent)}</div>

        <div className="meta-label">Firma</div>
        <div className="meta-value">{nbspIfEmpty(Firma)}</div>

        {/* Uz nase vozilo ide i vozac — interni po sifri ili tudji kao tekst.
            Procedura ih spaja u jedno polje, pa stampa samo ispisuje "vozilo / vozac". */}
        <div className="meta-label">Registracija / Vozač</div>
        <div className="meta-value">
          {nbspIfEmpty([Registracija, Vozac].filter(Boolean).join(" / "))}
        </div>
      </div>

      <div className="items-title">Stavke:</div>

      <table className="items-table">
        <thead>
          <tr>
            <th className="col-rb"       style={{ border: "1px solid #000" }}>RB</th>
            <th className="col-sifra"    style={{ border: "1px solid #000" }}>Šifra artikla</th>
            <th className="col-artikal"  style={{ border: "1px solid #000" }}>Artikal</th>
            <th className="col-kolicina" style={{ border: "1px solid #000" }}>Količina</th>
            <th className="col-jm"       style={{ border: "1px solid #000" }}>JM</th>
            <th className="col-neto"     style={{ border: "1px solid #000" }}>Neto (kg)</th>
            <th className="col-bruto"    style={{ border: "1px solid #000" }}>Bruto (kg)</th>
            <th className="col-magacin"  style={{ border: "1px solid #000" }}>Magacin</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(Stavke) && Stavke.length > 0 ? (
            Stavke.map((stavka, index) => (
              <tr key={index}>
                <td className="col-rb text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.RB ?? index + 1)}
                </td>
                <td className="col-sifra text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.["Šifra artikla"])}
                </td>
                <td className="col-artikal text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.Artikal)}
                </td>
                <td className="col-kolicina text-center fontSizeTd">
                  {stavka?.Količina ?? "\u00A0"}
                </td>
                <td className="col-jm text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.JM)}
                </td>
                {/* Prazno, a ne nula, kad artikal nema upisanu tezinu — nula bi
                    znacila „ne tezi nista", a istina je „ne znamo". Procedura
                    zato polje i izostavi umesto da posalje 0. */}
                <td className="col-neto text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.["Neto kg"])}
                </td>
                <td className="col-bruto text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.["Bruto kg"])}
                </td>
                <td className="col-magacin text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.Magacin)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="text-center" style={{ height: "42px" }}>
                Nema stavki
              </td>
            </tr>
          )}

          {/* Zbirni red ide samo kad ima sta da se sabere. Prazan red sa nulama bi
              na papiru za granicu izgledao kao da posiljka nema tezinu. */}
          {Array.isArray(Stavke) && Stavke.length > 0 && (UkupnoNeto !== "" || UkupnoBruto !== "") && (
            <tr className="red-zbir">
              <td colSpan={5} className="text-right fontSizeTd" style={{ border: "1px solid #000" }}>
                UKUPNO:
              </td>
              <td className="col-neto text-center fontSizeTd" style={{ border: "1px solid #000" }}>
                {nbspIfEmpty(UkupnoNeto)}
              </td>
              <td className="col-bruto text-center fontSizeTd" style={{ border: "1px solid #000" }}>
                {nbspIfEmpty(UkupnoBruto)}
              </td>
              <td style={{ border: "1px solid #000" }}>&nbsp;</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Zbir koji ne obuhvata sve stavke MORA da se oznaci. Po ovom papiru se
          postupa na granici, pa bi precutana razlika znacila da carinik dobije
          manju tezinu nego sto posiljka stvarno ima, i to kao tacan podatak. */}
      {Number(BezTezine) > 0 && (
        <div className="zbir-nepotpun">
          Napomena: {Number(BezTezine) === 1
            ? "jedna stavka nema upisanu težinu artikla"
            : Number(BezTezine) + " stavki nema upisanu težinu artikla"}
          , pa zbir nije potpun.
        </div>
      )}

      <div style={{ marginTop: "1%", minWidth: "100%", borderTop: "1px black dotted" }}></div>

      <div className="note-box">
        <div className="note-title">Napomena</div>
        <div className="note-value">{nbspIfEmpty(Napomena)}</div>
      </div>

      <div className="signature-wrap">
        <div className="signature-box">
          <div className="signature-line">Predao</div>
        </div>
        <div className="signature-box">
          <div className="signature-line">Primio</div>
        </div>
      </div>
    </div>
  );
};

export default OtpremnicaZaStampu;
